import React from 'react';
import LinkIcon from '@mui/icons-material/Link';

export const linkIcon = (
  value: boolean,
  selected: string,
  disabled: string
) => (
  <LinkIcon
    style={{ width: '18', color: value ? selected : disabled }}
    id="iconMenu-icon-link"
  />
);
